export const FEATURE_FLAGS = {
  INTAKE_V2_LAND_TITLE: false,
};
